// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.viewUser_dashboard__nwNkc {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.viewUser_dashboardContain__zNYvn {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.viewUser_bodythemedark__zkPzD .viewUser_dashboardContain__zNYvn,
.viewUser_bodythemedark__zkPzD .viewUser_dashboard__nwNkc,
.viewUser_bodythemedark__zkPzD .viewUser_cont2__69lMj {
  background-Color: #0f1824;
}

.viewUser_top_header__OIa59 .viewUser_top_header_inner__k\\+1kS {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.viewUser_cont2__69lMj {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.viewUser_subLink__fuP02 svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.viewUser_footer__liLtj {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.viewUser_bodythemelight__5XfSi {
  background-color: #fff;
  padding-top: 90px;
}

.viewUser_bodythemedark__zkPzD {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.viewUser_headerthemelight__xnPq6 {
  background-color: #fff;
}

.viewUser_headerthemedark__FV-N2 {
  background-color: #132337;
}

.viewUser_top_header__OIa59 {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.viewUser_menuthemelight__8\\+TOW {
  background-color: #fff;
}

.viewUser_menuthemedark__liCwR {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.viewUser_menulinklight__tYAZq span {
  color: #666666 !important;
}

.viewUser_menulinklight__tYAZq a {
  color: #CBCBCB !important;
}

.viewUser_menulinklight__tYAZq:hover span, .viewUser_menulinklight__tYAZq:hover a {
  color: #fff !important;
}

.viewUser_menulinkdarkSelected__MVaiX {
  background-color: #1c2e45;
  color: #fff;
}

.viewUser_menuthemelight__8\\+TOW .viewUser_menulinklightSelected__Rz\\+Zc {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.viewUser_menulinkdark__9k7Il {
  color: #60677e !important;
}

.viewUser_menulinklight__tYAZq:hover {
  color: #fff !important;
  background-color: #205440;
}

.viewUser_menulinkdark__9k7Il:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.viewUser_headinglight__03G40 {
  color: #60677e;
}

.viewUser_headingdark__o4JTQ {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.viewUser_searchboxlight__8MNAv {
  background-color: #fff;
  border: none;
}

.viewUser_searchboxdark__UrSr- {
  background-color: #132337;
  color: #fff;
  border: none;
}

.viewUser_searchboxdark__UrSr-::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.viewUser_tableheadlight__p36Uk {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.viewUser_tableheadlight__p36Uk th {
  color: #fff;
}

thead .viewUser_tableheadlight__p36Uk th:first-child,
thead .viewUser_tableheaddark__SYWoT th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .viewUser_tableheadlight__p36Uk th:last-child,
thead .viewUser_tableheaddark__SYWoT th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.viewUser_table__nXbwF.viewUser_table-borderless__JVIQg {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.viewUser_tableheaddark__SYWoT {
  background-color: #1e1e2d;
  color: #fff;
}

.viewUser_table-borderless__JVIQg tr:nth-child(even) {
  background-color: #F9FAFB;
}

.viewUser_table-borderless__JVIQg .viewUser_left-section__q14yx {
  padding-top: 10px;
}

.viewUser_tablebodylight__0sfQg td,
.viewUser_tablebodydark__8fdD3 td {
  padding: 1rem 1rem !important;
}

.viewUser_tablebodylight__0sfQg {
  background-color: #fff;
}
.viewUser_tablebodylight__0sfQg:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.viewUser_tablebodydark__8fdD3 {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.viewUser_tablebodydark__8fdD3:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.viewUser_paginationlight__Z\\+SpZ {
  color: #60677e !important;
  font-size: 13px !important;
}

.viewUser_paginationdark__ZamRh {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.viewUser_formthemelight__6zWGT {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.viewUser_formthemedark__1nHzR {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.viewUser_formthemedark__1nHzR ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.viewUser_viewformlight__N\\+ZeF {
  background-color: #f3f6f9;
}

.viewUser_permissionboxlight__ri5cA {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.viewUser_permissionboxdark__gXei4 {
  background-color: #151521;
  border: solid 1px #242434;
}

.viewUser_errormsgclr__fennV {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.viewUser_graphclrlight__u7ucF {
  background-color: #fff;
}

.viewUser_graphclrdark__42UDv {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#viewUser_card1bglight__UnXvv {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#viewUser_card1bglight__UnXvv:hover {
  background: #f7fffc;
}

#viewUser_card1bgdark__2KuH7 {
  background: #392f28;
}

#viewUser_card1bgdark__2KuH7:hover {
  background: #f7fffc;
}

#viewUser_card2bglight__6JA13 {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#viewUser_card2bglight__6JA13:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#viewUser_card2bgdark__9klHf {
  background: #1c3238;
}

#viewUser_card3bglight__kfiUy {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#viewUser_card3bglight__kfiUy:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#viewUser_card3bgdark__rZ4mu {
  background: #3a2434;
}

#viewUser_card4bglight__wjPB1 {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#viewUser_card4bglight__wjPB1:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#viewUser_card4bgdark__F9-tI {
  background: #2f264f;
}

#viewUser_card1bgdark__2KuH7 a, #viewUser_card1bgdark__2KuH7 p,
#viewUser_card2bgdark__9klHf a, #viewUser_card2bgdark__9klHf p,
#viewUser_card3bgdark__rZ4mu a, #viewUser_card3bgdark__rZ4mu p,
#viewUser_card4bgdark__F9-tI a, #viewUser_card4bgdark__F9-tI p {
  color: #fff;
}

/* 
Action button theme
*/
.viewUser_actionbtnlight__qB0ay {
  color: rgba(70, 71, 91, 0.8705882353);
}

.viewUser_actionbtndark__Kq9bp {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.viewUser_profiledropdownlight__8F0\\+c {
  background-color: #fff;
}

.viewUser_profiledropdowndark__YqYph {
  background-color: #151521;
}

.viewUser_settingsection__0P72U #viewUser_addform__wMqFW.viewUser_formthemedark__1nHzR .viewUser_savebtn__7M3T2 {
  background-color: #0a2574;
  color: #fff;
}

#viewUser_addform__wMqFW.viewUser_formthemedark__1nHzR .viewUser_savebtn__7M3T2 {
  background-color: #0a2574;
  color: #fff;
}

.viewUser_profile_conatiner__XZ68E {
  border-radius: 5px !important;
}

.viewUser_bodythemedark__zkPzD .viewUser_ag-theme-alpine__yLX5f .viewUser_ag-row__MaXI4 {
  background: #000 !important;
}

.viewUser_bodythemedark__zkPzD .viewUser_formbtn__tsdlQ {
  background-color: #0a2574;
}

.viewUser_bodythemedark__zkPzD .viewUser_resetbtn__wmUx\\+ {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.viewUser_bodythemedark__zkPzD .viewUser_resetbtn__wmUx\\+:hover {
  background-color: #0a2574;
}

.viewUser_headingdark__o4JTQ span {
  background-color: #132337;
}

.viewUser_resetbtn__wmUx\\+ {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.viewUser_resetbtn__wmUx\\+:hover,
.viewUser_resetbtn__wmUx\\+:active,
.viewUser_resetbtn__wmUx\\+:focus {
  background-color: #205440;
  color: #fff;
}

.viewUser_addBtn__F39dK {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.viewUser_addBtn__F39dK svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.viewUser_addBtn__F39dK:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.viewUser_cust_addBtn__Z8-Rc.viewUser_addBtn__F39dK svg {
  top: 2px;
}

.viewUser_deleteBtn__nde0v {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.viewUser_deleteBtn__nde0v {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.viewUser_deleteBtn__nde0v:active, .viewUser_deleteBtn__nde0v:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.viewUser_deleteBtn__nde0v svg {
  position: relative;
  top: -2px;
}

.viewUser_deleteBtn__nde0v:hover,
.viewUser_deleteBtn__nde0v:active,
.viewUser_deleteBtn__nde0v:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.viewUser_confirmBtn__BcBkQ {
  background-color: #205440;
}

.viewUser_confirmBtn__BcBkQ:hover,
.viewUser_confirmBtn__BcBkQ:active,
.viewUser_confirmBtn__BcBkQ:focus {
  background-color: #205440;
}

.viewUser_confirmBtn__BcBkQ svg {
  top: 0;
}

.viewUser_back_dlt__\\+ryQx {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.viewUser_delPopContainer__XJ8uN .viewUser_modal-body__dISeD {
  padding: 25px;
  text-align: center;
}

.viewUser_delPopContainer__XJ8uN .viewUser_delet_icon__hDPHY {
  margin-bottom: 11px;
}

.viewUser_delPopContainer__XJ8uN p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.viewUser_arrowback__UzifW svg {
  fill: #000;
}

.viewUser_bodythemedark__zkPzD .viewUser_arrowback__UzifW {
  background-color: #0a2574;
  color: #fff;
}

.viewUser_bodythemedark__zkPzD .viewUser_arrowback__UzifW svg {
  fill: #fff;
}

.viewUser_bodythemedark__zkPzD .viewUser_drpdwn_btn__ZNpvt {
  background-color: #132337;
}

.viewUser_bodythemedark__zkPzD .viewUser_empname__r53ua {
  color: #60677e !important;
}

.viewUser_bodythemedark__zkPzD .viewUser_navitemli__V3xgl a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.viewUser_bodythemedark__zkPzD .viewUser_tabnavli__2a26f a.viewUser_settingsgeneral__6UP6o,
.viewUser_bodythemedark__zkPzD .viewUser_tabnavli__2a26f a.viewUser_settingslinks__O\\+h4X:hover {
  background-color: #0a2574;
  color: #fff;
}

.viewUser_bodythemedark__zkPzD .viewUser_tabnavli__2a26f a.viewUser_settingslinks__O\\+h4X {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .viewUser_tableheadlight__p36Uk th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .viewUser_dashboard__nwNkc {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #viewUser_dashboardcont2__27KOG {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .viewUser_sectionright__J\\+KVV {
    float: unset !important;
  }
  .viewUser_dashboard__nwNkc {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .viewUser_cont2__69lMj {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .viewUser_bodythemelight__5XfSi, .viewUser_bodythemedark__zkPzD {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .viewUser_exer_modal_contain__Rfc\\+3 .viewUser_modal-dialog__DWiPe {
    max-width: 1055px;
  }
  .viewUser_delPopContainer__XJ8uN .viewUser_modal-dialog__DWiPe {
    max-width: 350px;
  }
}
#viewUser_addform__wMqFW {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 20px;
}
#viewUser_addform__wMqFW #viewUser_addheading__gsRP1 {
  font-size: 18px;
  margin-left: 10px;
}
#viewUser_addform__wMqFW .viewUser_profilepicdiv__y9Aw1 {
  padding: 0px;
  border-radius: 5px;
  text-align: center;
}
#viewUser_addform__wMqFW .viewUser_profilepic__S1t97 {
  width: 100%;
  border-radius: 5px;
}
#viewUser_addform__wMqFW .viewUser_namesection__wLA\\+6 {
  display: inline-block;
}
#viewUser_addform__wMqFW .viewUser_profilename__JlobT {
  font-size: 16px;
  margin-left: 20px;
  margin-top: 30px;
}
#viewUser_addform__wMqFW .viewUser_profileemail__5ZfIu {
  font-size: 14px;
  margin-left: 20px;
}
#viewUser_addform__wMqFW #viewUser_empdiv__teOCa {
  padding: 0px;
  margin-bottom: 20px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  background-color: transparent;
}
#viewUser_addform__wMqFW #viewUser_empdiv__teOCa .viewUser_title__IAd1a {
  font-size: 13px;
}
#viewUser_addform__wMqFW #viewUser_empdiv__teOCa .viewUser_empname__r53ua {
  font-size: 16px;
  color: #205440;
  font-weight: 600;
  margin-bottom: 0px;
}
#viewUser_addform__wMqFW .viewUser_arrowback__UzifW {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #205440;
  cursor: pointer;
  border-radius: 3px;
}
#viewUser_addform__wMqFW .viewUser_arrowback__UzifW:hover {
  background-color: #205440;
  color: #fff;
}

.viewUser_profile_view_container__1dVr\\+ {
  padding: 30px;
}

.viewUser_profile_view_container__1dVr\\+ span {
  font-size: 13px;
  margin-bottom: 7px;
}

@media only screen and (max-width: 600px) {
  #viewUser_dashboardcont2__27KOG {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/artist/viewUser.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAjpBA;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAmpBJ;AAjpBI;EACI,eAAA;EAEA,iBAAA;AAkpBR;AA/oBI;EACI,YAAA;EACA,kBAAA;EACA,kBAAA;AAipBR;AA9oBI;EACI,WAAA;EACA,kBAAA;AAgpBR;AA9oBI;EACI,qBAAA;AAgpBR;AA7oBI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;AA+oBR;AA7oBI;EACI,eAAA;EAEA,iBAAA;AA8oBR;AAzoBQ;EACI,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;AA2oBZ;AAzoBY;EAEI,eAAA;AA0oBhB;AAvoBY;EACI,eAAA;EACA,cDxCA;ECyCA,gBD/CA;ECgDA,kBAAA;AAyoBhB;AAnoBQ;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAqoBZ;AAnoBc;EACE,yBAAA;EACA,WAAA;AAqoBhB;;AAhoBA;EACI,aAAA;AAmoBJ;;AAhoBA;EACI,eAAA;EACA,kBAAA;AAmoBJ;;AA9nBA;EACI;IACI,wBDdI;ICeJ,UDdG;ICeH,kBAAA;IACA,aDtBW;ECupBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n    margin-bottom: 20px;\n   \n    #addheading{\n        font-size: 18px;\n         \n        margin-left: 10px;\n    }\n\n    .profilepicdiv{\n        padding: 0px;\n        border-radius: 5px;\n        text-align: center;\n    }\n\n    .profilepic{\n        width: 100%;\n        border-radius: 5px;\n    }\n    .namesection{\n        display: inline-block;\n    }\n\n    .profilename{\n        font-size: 16px;\n        margin-left: 20px;\n        margin-top: 30px;\n    }\n    .profileemail{\n        font-size: 14px;\n         \n        margin-left: 20px;\n    }\n   \n\n\n        #empdiv{\n            padding: 0px;\n            margin-bottom: 20px;\n            border-radius: 5px;\n            display: flex;\n            align-items: center;\n            background-color: transparent;\n\n            .title{\n                 \n                font-size: 13px;\n            }\n\n            .empname{\n                font-size: 16px;\n                color: $primary-color;\n                font-weight: $font-semiBold;\n                margin-bottom: 0px;\n                // padding-bottom:8px;\n            }\n        }\n\n        \n        .arrowback{\n            float: right;\n            background-color: #dde2eb;\n            padding: 10px;\n            color: #205440;\n            cursor: pointer;\n            border-radius: 3px;\n    \n              &:hover{\n                background-color: #205440;\n                color: #fff;\n              }\n          }\n}\n\n.profile_view_container {\n    padding: 30px;\n}\n\n.profile_view_container span {\n    font-size: 13px;\n    margin-bottom: 7px;\n}\n\n\n\n@media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `viewUser_dashboard__nwNkc`,
	"dashboardContain": `viewUser_dashboardContain__zNYvn`,
	"bodythemedark": `viewUser_bodythemedark__zkPzD`,
	"cont2": `viewUser_cont2__69lMj`,
	"top_header": `viewUser_top_header__OIa59`,
	"top_header_inner": `viewUser_top_header_inner__k+1kS`,
	"subLink": `viewUser_subLink__fuP02`,
	"footer": `viewUser_footer__liLtj`,
	"bodythemelight": `viewUser_bodythemelight__5XfSi`,
	"headerthemelight": `viewUser_headerthemelight__xnPq6`,
	"headerthemedark": `viewUser_headerthemedark__FV-N2`,
	"menuthemelight": `viewUser_menuthemelight__8+TOW`,
	"menuthemedark": `viewUser_menuthemedark__liCwR`,
	"menulinklight": `viewUser_menulinklight__tYAZq`,
	"menulinkdarkSelected": `viewUser_menulinkdarkSelected__MVaiX`,
	"menulinklightSelected": `viewUser_menulinklightSelected__Rz+Zc`,
	"menulinkdark": `viewUser_menulinkdark__9k7Il`,
	"headinglight": `viewUser_headinglight__03G40`,
	"headingdark": `viewUser_headingdark__o4JTQ`,
	"searchboxlight": `viewUser_searchboxlight__8MNAv`,
	"searchboxdark": `viewUser_searchboxdark__UrSr-`,
	"tableheadlight": `viewUser_tableheadlight__p36Uk`,
	"tableheaddark": `viewUser_tableheaddark__SYWoT`,
	"table": `viewUser_table__nXbwF`,
	"table-borderless": `viewUser_table-borderless__JVIQg`,
	"left-section": `viewUser_left-section__q14yx`,
	"tablebodylight": `viewUser_tablebodylight__0sfQg`,
	"tablebodydark": `viewUser_tablebodydark__8fdD3`,
	"paginationlight": `viewUser_paginationlight__Z+SpZ`,
	"paginationdark": `viewUser_paginationdark__ZamRh`,
	"formthemelight": `viewUser_formthemelight__6zWGT`,
	"formthemedark": `viewUser_formthemedark__1nHzR`,
	"viewformlight": `viewUser_viewformlight__N+ZeF`,
	"permissionboxlight": `viewUser_permissionboxlight__ri5cA`,
	"permissionboxdark": `viewUser_permissionboxdark__gXei4`,
	"errormsgclr": `viewUser_errormsgclr__fennV`,
	"graphclrlight": `viewUser_graphclrlight__u7ucF`,
	"graphclrdark": `viewUser_graphclrdark__42UDv`,
	"card1bglight": `viewUser_card1bglight__UnXvv`,
	"card1bgdark": `viewUser_card1bgdark__2KuH7`,
	"card2bglight": `viewUser_card2bglight__6JA13`,
	"card2bgdark": `viewUser_card2bgdark__9klHf`,
	"card3bglight": `viewUser_card3bglight__kfiUy`,
	"card3bgdark": `viewUser_card3bgdark__rZ4mu`,
	"card4bglight": `viewUser_card4bglight__wjPB1`,
	"card4bgdark": `viewUser_card4bgdark__F9-tI`,
	"actionbtnlight": `viewUser_actionbtnlight__qB0ay`,
	"actionbtndark": `viewUser_actionbtndark__Kq9bp`,
	"profiledropdownlight": `viewUser_profiledropdownlight__8F0+c`,
	"profiledropdowndark": `viewUser_profiledropdowndark__YqYph`,
	"settingsection": `viewUser_settingsection__0P72U`,
	"addform": `viewUser_addform__wMqFW`,
	"savebtn": `viewUser_savebtn__7M3T2`,
	"profile_conatiner": `viewUser_profile_conatiner__XZ68E`,
	"ag-theme-alpine": `viewUser_ag-theme-alpine__yLX5f`,
	"ag-row": `viewUser_ag-row__MaXI4`,
	"formbtn": `viewUser_formbtn__tsdlQ`,
	"resetbtn": `viewUser_resetbtn__wmUx+`,
	"addBtn": `viewUser_addBtn__F39dK`,
	"cust_addBtn": `viewUser_cust_addBtn__Z8-Rc`,
	"deleteBtn": `viewUser_deleteBtn__nde0v`,
	"confirmBtn": `viewUser_confirmBtn__BcBkQ`,
	"back_dlt": `viewUser_back_dlt__+ryQx`,
	"delPopContainer": `viewUser_delPopContainer__XJ8uN`,
	"modal-body": `viewUser_modal-body__dISeD`,
	"delet_icon": `viewUser_delet_icon__hDPHY`,
	"arrowback": `viewUser_arrowback__UzifW`,
	"drpdwn_btn": `viewUser_drpdwn_btn__ZNpvt`,
	"empname": `viewUser_empname__r53ua`,
	"navitemli": `viewUser_navitemli__V3xgl`,
	"tabnavli": `viewUser_tabnavli__2a26f`,
	"settingsgeneral": `viewUser_settingsgeneral__6UP6o`,
	"settingslinks": `viewUser_settingslinks__O+h4X`,
	"dashboardcont2": `viewUser_dashboardcont2__27KOG`,
	"sectionright": `viewUser_sectionright__J+KVV`,
	"exer_modal_contain": `viewUser_exer_modal_contain__Rfc+3`,
	"modal-dialog": `viewUser_modal-dialog__DWiPe`,
	"addheading": `viewUser_addheading__gsRP1`,
	"profilepicdiv": `viewUser_profilepicdiv__y9Aw1`,
	"profilepic": `viewUser_profilepic__S1t97`,
	"namesection": `viewUser_namesection__wLA+6`,
	"profilename": `viewUser_profilename__JlobT`,
	"profileemail": `viewUser_profileemail__5ZfIu`,
	"empdiv": `viewUser_empdiv__teOCa`,
	"title": `viewUser_title__IAd1a`,
	"profile_view_container": `viewUser_profile_view_container__1dVr+`
};
export default ___CSS_LOADER_EXPORT___;
